"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAnnualMotorWidgets = void 0;
var AnnualMotorReplaceCarPriceWidget_1 = require("./AnnualMotorReplaceCarPriceWidget");
var AnnualMotorReplaceCarSummaryPanelWidget_1 = require("./AnnualMotorReplaceCarSummaryPanelWidget");
var CarUsageChoiceWidgetWithPopup_1 = require("./CarUsageChoiceWidgetWithPopup");
var AnnualQuoteSummaryPanelWidget_1 = require("./AnnualQuoteSummaryPanelWidget");
var AnnualVehicleEditorWidget_1 = require("./AnnualVehicleEditorWidget");
var WolfMTADeclineTextOutputWidget_1 = require("./WolfMTADeclineTextOutputWidget");
var AnnualCoverRefundCancellationOutput_1 = require("./AnnualCoverRefundCancellationOutput");
var EditPhoneNumberPopupWidget_1 = require("./EditPhoneNumberPopupWidget");
var ProtectedNcdWidget_1 = require("./optionalExtras/ProtectedNcdWidget");
var WolfRenewalMTADeclineOutputTextWidget_1 = require("./WolfRenewalMTADeclineOutputTextWidget");
var AddressDisplayWidget_1 = require("./AddressDisplayWidget");
var AnnualCarCoverDetailsWidget_1 = require("./AnnualCarCoverDetailsWidget");
var AnnualMotorAddAdditionalDriverPayWidget_1 = require("./AnnualMotorAddAdditionalDriverPayWidget");
var AnnualPremiumChoiceWidget_1 = require("./AnnualPremiumChoiceWidget");
var AutomaticRenewalCheckboxWidget_1 = require("./AutomaticRenewalCheckboxWidget");
var DisplayAnnualCarDetailsWidget_1 = require("./DisplayAnnualCarDetailsWidget");
var EditDriverPanelWidget_1 = require("./EditDriverPanelWidget");
var ForcedPaymentPlanChangeModalWidget_1 = require("./ForcedPaymentPlanChangeModalWidget");
var PreContractCreditAgreement_1 = require("./PreContractCreditAgreement");
var VehicleDeclineModalWidget_1 = require("./VehicleDeclineModalWidget");
var WolfCarPanelWidget_1 = require("./WolfCarPanelWidget");
var WolfEditCarPanelExcessWidget_1 = require("./WolfEditCarPanelExcessWidget");
var AnnualMotorPremiumWidget_1 = require("./AnnualMotorPremiumWidget");
var AnnualMotorOptionalExtrasWidget_1 = require("./optionalExtras/AnnualMotorOptionalExtrasWidget");
var AnnualProductPaymentChoiceWidget_1 = require("./AnnualProductPaymentChoiceWidget");
var DrivingExperienceQuestionWidget_1 = require("./DrivingExperienceQuestionWidget");
var AnnualMotorTierWidget_1 = require("./AnnualMotorTierWidget");
var IncludedAsStandardWidget_1 = require("../../motorCommon/IncludedAsStandardWidget");
var AutomaticRenewalCancellationReasonWidget_1 = require("./AutomaticRenewalCancellationReasonWidget");
var CancelPolicyOrAutomaticRenewalChoiceWidget_1 = require("./CancelPolicyOrAutomaticRenewalChoiceWidget");
var FalconNavigatorHeaderWidget_1 = require("./FalconNavigatorHeaderWidget");
var NotificationModalWidget_1 = require("./NotificationModalWidget");
var UniqueSellingPointWidget_1 = require("./UniqueSellingPointWidget");
var EditVehicleRegistrationNumberInformation_1 = require("./EditVehicleRegistrationNumberInformation");
var AnnualDriveAwayChoiceWidget_1 = require("./AnnualDriveAwayChoiceWidget");
var TierSummaryWidget_1 = require("./TierSummaryWidget");
var CoverCancellationOutput_1 = require("../../CoverCancellationOutput");
var PromotionsContributionBanner_1 = require("../../driveAway/PromotionsContributionBanner");
var OnlySingleEligibleTierWidget_1 = require("./OnlySingleEligibleTierWidget");
var PolicyNumberWidget_1 = require("./renewal/PolicyNumberWidget");
var AnnualMotorRenewalPaymentChoiceWidget_1 = require("./renewal/AnnualMotorRenewalPaymentChoiceWidget");
var TierSummaryRenewalWidget_1 = require("./renewal/car/TierSummaryRenewalWidget");
var AnnualMotorRenewalPolicyDetailsWidget_1 = require("./renewal/AnnualMotorRenewalPolicyDetailsWidget");
var AnnualMotorPolicyDetailsWidget_1 = require("./renewal/AnnualMotorPolicyDetailsWidget");
var AnnualMotorRenewalCarDetailsWidget_1 = require("./renewal/car/AnnualMotorRenewalCarDetailsWidget");
var AnnualMotorRenewalDriverDetailsWidget_1 = require("./renewal/AnnualMotorRenewalDriverDetailsWidget");
var RenewalSaveSuccessModalWidget_1 = require("./renewal/RenewalSaveSuccessModalWidget");
var RenewalPremiumTypeChangeModal_1 = require("./renewal/RenewalPremiumTypeChangeModal");
var AnnualMotorRenewalEditCarExcessWidget_1 = require("./renewal/car/AnnualMotorRenewalEditCarExcessWidget");
var RenewalEditDriverPanelWidget_1 = require("./renewal/driver/RenewalEditDriverPanelWidget");
var RenewalSummaryPagePremiumWidget_1 = require("./RenewalSummaryPagePremiumWidget");
var RenewalMonthlyPaymentPlanOutput_1 = require("./RenewalMonthlyPaymentPlanOutput");
var addAnnualMotorWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorReplaceCarPriceWidget",
        component: AnnualMotorReplaceCarPriceWidget_1.AnnualMotorReplaceCarPriceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorReplaceCarSummaryPanelWidget",
        component: AnnualMotorReplaceCarSummaryPanelWidget_1.AnnualMotorReplaceCarSummaryPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "carUsageChoiceWidgetWithPopup",
        component: CarUsageChoiceWidgetWithPopup_1.CarUsageChoiceWidgetWithPopup
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualQuoteSummaryPanel",
        component: AnnualQuoteSummaryPanelWidget_1.AnnualQuoteSummaryPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualVehicleEdit",
        component: AnnualVehicleEditorWidget_1.AnnualVehicleEditorWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "wolfMTADeclineTextOutputWidget",
        component: WolfMTADeclineTextOutputWidget_1.WolfMTADeclineTextOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "wolfRenewalMTADeclineTextOutputWidget",
        component: WolfRenewalMTADeclineOutputTextWidget_1.WolfRenewalMTADeclineOutputTextWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualCoverRefundCancellationOutput",
        component: AnnualCoverRefundCancellationOutput_1.AnnualCoverRefundCancellationOutput
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "coverCancellationOutput",
        component: CoverCancellationOutput_1.CoverCancellationOutput
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "editPhoneNumberPopup",
        component: EditPhoneNumberPopupWidget_1.EditPhoneNumberPopupWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "protectedNcdWidget",
        component: ProtectedNcdWidget_1.ProtectedNcdWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addressDisplay",
        component: AddressDisplayWidget_1.AddressDisplayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualCarCoverDetailsOutput",
        component: AnnualCarCoverDetailsWidget_1.AnnualCarCoverDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorAddAdditionalDriverPayWidgetOutput",
        component: AnnualMotorAddAdditionalDriverPayWidget_1.AnnualMotorAddAdditionalDriverPayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualProductPaymentChoice",
        component: AnnualProductPaymentChoiceWidget_1.AnnualProductPaymentChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "motorIncludedAsStandardWidget",
        component: IncludedAsStandardWidget_1.IncludedAsStandardWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorTierWidget",
        component: AnnualMotorTierWidget_1.AnnualMotorTierWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualPremiumChoice",
        component: AnnualPremiumChoiceWidget_1.AnnualPremiumChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "automaticRenewalCheckboxWidget",
        component: AutomaticRenewalCheckboxWidget_1.AutomaticRenewalCheckboxWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "displayAnnualCarDetails",
        component: DisplayAnnualCarDetailsWidget_1.DisplayAnnualCarDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "editDriverPanel",
        component: EditDriverPanelWidget_1.EditDriverPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "forcedPaymentPlanChangeModal",
        component: ForcedPaymentPlanChangeModalWidget_1.ForcedPaymentPlanChangeModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "preContractCreditAgreement",
        component: PreContractCreditAgreement_1.PreContractCreditAgreement
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "vehicleDeclineModal",
        component: VehicleDeclineModalWidget_1.VehicleDeclineModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "wolfCarPanelOutput",
        component: WolfCarPanelWidget_1.WolfCarPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "wolfEditCarExcessOutput",
        component: WolfEditCarPanelExcessWidget_1.WolfEditCarExcessWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorPremiumOutput",
        component: AnnualMotorPremiumWidget_1.AnnualMotorPremiumWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "optionalExtrasAnnualMotor",
        component: AnnualMotorOptionalExtrasWidget_1.AnnualMotorOptionalExtrasWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "drivingExperienceQuestion",
        component: DrivingExperienceQuestionWidget_1.DrivingExperienceQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalCancellationReasons",
        component: AutomaticRenewalCancellationReasonWidget_1.AutomaticRenewalCancellationReasonWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "cancelPolicyOrAutomaticRenewalChoiceWidget",
        component: CancelPolicyOrAutomaticRenewalChoiceWidget_1.CancelPolicyOrAutomaticRenewalChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconNavigatorHeader",
        component: FalconNavigatorHeaderWidget_1.FalconNavigatorHeaderWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "notificationModal",
        component: NotificationModalWidget_1.NotificationModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "uniqueSellingPointWidget",
        component: UniqueSellingPointWidget_1.UniqueSellingPointQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "editVehicleRegistrationNumberInformation",
        component: EditVehicleRegistrationNumberInformation_1.EditVehicleRegistrationNumberInformation
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualDriveAwayChoice",
        component: AnnualDriveAwayChoiceWidget_1.AnnualDriveAwayChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "tierSummaryWidget",
        component: TierSummaryWidget_1.TierSummaryWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "promotionsContributionBanner",
        component: PromotionsContributionBanner_1.PromotionsContributionBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "onlySingleEligibleTierWidget",
        component: OnlySingleEligibleTierWidget_1.OnlySingleEligibleTierWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "policyNumber",
        component: PolicyNumberWidget_1.PolicyNumberWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorRenewalPaymentChoice",
        component: AnnualMotorRenewalPaymentChoiceWidget_1.AnnualMotorRenewalPaymentChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "tierSummaryRenewalWidget",
        component: TierSummaryRenewalWidget_1.TierSummaryRenewalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorPolicyDetails",
        component: AnnualMotorPolicyDetailsWidget_1.AnnualMotorPolicyDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorRenewalPolicyDetails",
        component: AnnualMotorRenewalPolicyDetailsWidget_1.AnnualMotorRenewalPolicyDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorRenewalCarDetails",
        component: AnnualMotorRenewalCarDetailsWidget_1.AnnualMotorRenewalCarDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorRenewalDriverDetails",
        component: AnnualMotorRenewalDriverDetailsWidget_1.AnnualMotorRenewalDriverDetailsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalSaveSuccessModalWidget",
        component: RenewalSaveSuccessModalWidget_1.RenewalSaveSuccessModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalPremiumTypeChangeModal",
        component: RenewalPremiumTypeChangeModal_1.RenewalPremiumTypeChangeModal
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualMotorRenewalEditCarExcess",
        component: AnnualMotorRenewalEditCarExcessWidget_1.AnnualMotorRenewalEditCarExcessWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalEditDriverPanel",
        component: RenewalEditDriverPanelWidget_1.RenewalEditDriverPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalSummaryPagePremiumWidget",
        component: RenewalSummaryPagePremiumWidget_1.RenewalSummaryPagePremiumWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalMonthlyPaymentPlanOutput",
        component: RenewalMonthlyPaymentPlanOutput_1.RenewalMonthlyPaymentPlanOutput
    });
};
exports.addAnnualMotorWidgets = addAnnualMotorWidgets;
//# sourceMappingURL=index.js.map